import './src/Core.js'
import './src/Tabs.js'
import './src/Config.js'
import './src/Debugger.js'
